import styled from 'styled-components';

export const Row = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const Column = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-top: ${({paddingTop}) => paddingTop}
`;

export const ColumnCenterContent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const Title = styled.span`
    color: #505154;
    font-size: 14px;
    font-weight: bold;
`;

export const Input = styled.input`
    width: 60px;
    color: ${({ isActive }) => isActive ? '#505154' : '#B5B5B5'};
    font-size: 14px;
    font-weight: bold;
    padding: 4px 0;
    text-align: center;
    border: 1px solid #B5B5B5;
    outline-color: #09CFFD;
    caret-color: ${({ caretColor }) => caretColor ? caretColor : '#505154'};
`;
